buyBonusPopup = {};

buyBonusPopup.infoText = undefined;
buyBonusPopup.open = false;

buyBonusPopup.show = function (callback) {
  buyBonusPopup.open = true;

  //buyBonusPopup.freeSpinsButton.enableButton(true);

  buyBonusPopup.closeButton.enableButton(true);

  //encoreButton.cancelEncore();
  //messageBus.post("game:modal", { reason: "buy_bonus" });

  const highFreeSpinStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_HIGH.coinSizes;
  const medFreeSpinStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_MED.coinSizes;
  const lowFreeSpinsStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_LOW.coinSizes;

  // combine all the stakes and remove duplicates - then sort
  // this might all go wrong with stake indexes as some stakes will only be in one mode and not the other
  buyBonusPopup.allStakesCombined = lowFreeSpinsStakes.concat(
    medFreeSpinStakes.filter(function (el) {
      medFreeSpinStakes.indexOf(el) === -1;
    }),
    highFreeSpinStakes.filter(function (el) {
      highFreeSpinStakes.indexOf(el) === -1;
    })
  );

  buyBonusPopup.allStakesCombined.sort(function (a, b, c) {
    return a - b - c;
  });

  // if the buy a bonus default stakes are different we choose the lowest of the two - game design
  const MedFreeSpinsDefault = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_MED.defaultAmountPerLine;
  const fsDefault = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_LOW.defaultAmountPerLine;

  let defaultToUse = MedFreeSpinsDefault;

  if (MedFreeSpinsDefault !== fsDefault) {
    console.log("WARNING: Default buy a bonus stakes differ between modes");
    defaultToUse = Math.min(MedFreeSpinsDefault, fsDefault);
  }

  const crtBaseStake = gameController.globalHelperGetBaseStake();
  const stakeController = resourceManager.getController("stakeController");
  const numLines = stakeController.CurrentWinLineCount;
  const index = buyBonusPopup.allStakesCombined.findIndex((stake) => stake * numLines === crtBaseStake);

  if (index !== -1) {
    buyBonusPopup.combinedStakeIndex = index;
  } else {
    buyBonusPopup.combinedStakeIndex = buyBonusPopup.allStakesCombined.length - 1;
  }

  buyBonusPopup.updatePopup();

  resourceManager.getContainer("buyABonusContainer").visible = true;
  buyBonusPopup.container.visible = true;
  buyBonusPopup.callback = callback;
};

buyBonusPopup.updatePopup = function () {
  if (buyBonusPopup.combinedStakeIndex === -1) {
    // Something went really wrong here. No compatible stakes found
    buyBonusPopup.stakePreviousButton.enableButton(false);
    buyBonusPopup.stakeNextButton.enableButton(false);
    buyBonusPopup.midFreespinsButton.enableButton(false);
    buyBonusPopup.highFreespinsButton.enableButton(false);
    buyBonusPopup.freeSpinsButton.enableButton(false);
  } else {
    const bonusBuyStakes = buyBonusPopup.allStakesCombined;

    // update the stake buttons
    buyBonusPopup.stakePreviousButton.enableButton(buyBonusPopup.combinedStakeIndex > 0);
    buyBonusPopup.stakeNextButton.enableButton(buyBonusPopup.combinedStakeIndex < bonusBuyStakes.length - 1);

    // update the base stake box
    let baseStake = buyBonusPopup.convertToTotalStake(bonusBuyStakes[buyBonusPopup.combinedStakeIndex]);
    buyBonusPopup.baseStakeText.setText(gdk.formatCurrency(baseStake));

    // check stake is valid for each buy a bonus mode
    const highFreeSpinStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_HIGH.coinSizes;
    const medFreeSpinStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_MED.coinSizes;
    const lowFreeSpinsStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_LOW.coinSizes;

    const stakeToFind = bonusBuyStakes[buyBonusPopup.combinedStakeIndex];

    let highFreespinsStakeExists = highFreeSpinStakes.includes(stakeToFind);
    let superFreespinsStakeExists = medFreeSpinStakes.includes(stakeToFind);
    let freeSpinsStakeExists = lowFreeSpinsStakes.includes(stakeToFind);

    // high free spins spins link costs
    let costHighFreespins = baseStake * buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsHigh;
    buyBonusPopup.highFreespinsLinkCostValue.setText(gdk.formatCurrency(costHighFreespins));
    buyBonusPopup.highFreespinsButton.enableButton(
      buyBonusPopup.balance >= costHighFreespins && highFreespinsStakeExists
    );

    // superfree spins link costs
    let costMedFreespins = baseStake * buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsMed;
    buyBonusPopup.midFreespinsLinkCostValue.setText(gdk.formatCurrency(costMedFreespins));
    buyBonusPopup.midFreespinsButton.enableButton(
      buyBonusPopup.balance >= costMedFreespins && superFreespinsStakeExists
    );

    // Free spins costs
    let costFreeSpins = baseStake * buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsLow;
    buyBonusPopup.lowFreespinsLinkCostValue.setText(gdk.formatCurrency(costFreeSpins));
    buyBonusPopup.lowFreespinsButton.enableButton(buyBonusPopup.balance >= costFreeSpins && freeSpinsStakeExists);
  }

  // Free Spin Amount
  buyBonusPopup.lowFSAmount.setText(7);
  buyBonusPopup.midFSAmount.setText(14);
  buyBonusPopup.highFSAmount.setText(21);
};

buyBonusPopup.create = function (json) {
  return new PIXI.Container();
};

buyBonusPopup.convertToTotalStake = function (coinSize) {
  const stakeController = resourceManager.getController("stakeController");
  const numLines = stakeController.CurrentWinLineCount;

  return coinSize * numLines;
};

buyBonusPopup.onStakeNextPressed = function () {
  soundManager.play("buttonPressed");

  const bonusBuyStakes = buyBonusPopup.allStakesCombined;
  buyBonusPopup.combinedStakeIndex = Math.min(buyBonusPopup.combinedStakeIndex + 1, bonusBuyStakes.length - 1);
  buyBonusPopup.updatePopup();
};

buyBonusPopup.onStakePreviousPressed = function () {
  soundManager.play("buttonPressed");

  buyBonusPopup.combinedStakeIndex = Math.max(buyBonusPopup.combinedStakeIndex - 1, 0);
  buyBonusPopup.updatePopup();
};

buyBonusPopup.initialise = function (json, container) {
  buyBonusPopup.container = container;
  buyBonusPopup.container.visible = false;

  buyBonusPopup.fadedMask = new PIXI.Graphics();
  buyBonusPopup.fadedMask.beginFill(0, 0.8);
  buyBonusPopup.fadedMask.drawRect(-10000, -10000, 20000, 20000);
  buyBonusPopup.fadedMask.endFill();
  buyBonusPopup.fadedMask.interactive = true;
  buyBonusPopup.container.addChild(buyBonusPopup.fadedMask);
  messageBus.subscribe("spinner:GameConfigEvent", buyBonusPopup.onGameConfig);
  messageBus.subscribe("common:BalanceEvent", buyBonusPopup.onBalanceEvent);
  messageBus.subscribe("game:modal", buyBonusPopup.onModal);

  buyBonusPopup.helpActive = false;
};

buyBonusPopup.onModal = function (data) {
  if (buyBonusPopup.container.visible) {
    if (data.reason && data.reason === "Options menu open") {
      buyBonusPopup.helpActive = true;

      buyBonusPopup.midFreespinsButton.enableButton(false);
      buyBonusPopup.lowFreespinsButton.enableButton(false);
      buyBonusPopup.closeButton.enableButton(false);

      buyBonusPopup.stakePreviousButton.enableButton(false);
      buyBonusPopup.stakeNextButton.enableButton(false);
    } else if (buyBonusPopup.helpActive) {
      buyBonusPopup.helpActive = false;

      buyBonusPopup.midFreespinsButton.enableButton(true);
      buyBonusPopup.lowFreespinsButton.enableButton(true);
      buyBonusPopup.closeButton.enableButton(true);

      buyBonusPopup.updatePopup();
    }

    // if (buyBonusPopup.open) {
    //   if (data.reason === undefined) {
    //     messageBus.post("game:modal", { reason: "buy_bonus" });
    //   }
    // }
  }
};

buyBonusPopup.init = function () {
  // buyBonusPopup.background = resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground");

  // GET HIGH BONUS BUY RESOURCES
  buyBonusPopup.highFreespinsButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyBonusBacking:buyABonusHigh:highFreespinsButton"
  );
  buyBonusPopup.highFreespinsButton.onPressedCallback = buyBonusPopup.onClickedYesHigh;

  buyBonusPopup.highFreespinsLinkCostValue = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyBonusBacking:buyABonusHigh:CostValue"
  );

  buyBonusPopup.highFSAmount = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyBonusBacking:buyABonusHigh:fsAmount"
  );

  // GET MID BONUS BUY RESOURCES
  buyBonusPopup.midFreespinsButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyBonusBacking:buyABonusMedium:midFreespinsButton"
  );
  buyBonusPopup.midFreespinsButton.onPressedCallback = buyBonusPopup.onClickedYesMid;

  buyBonusPopup.midFreespinsLinkCostValue = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyBonusBacking:buyABonusMedium:CostValue"
  );

  buyBonusPopup.midFSAmount = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyBonusBacking:buyABonusMedium:fsAmount"
  );

  // GET LOW BONUS BUY RESOURCES
  buyBonusPopup.lowFreespinsButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyBonusBacking:buyABonusLow:lowFreespinsButton"
  );
  buyBonusPopup.lowFreespinsButton.onPressedCallback = buyBonusPopup.onClickedYesLow;

  buyBonusPopup.lowFreespinsLinkCostValue = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyBonusBacking:buyABonusLow:CostValue"
  );

  buyBonusPopup.lowFSAmount = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyBonusBacking:buyABonusLow:fsAmount"
  );

  buyBonusPopup.baseStakeText = resourceManager.get("buyABonusContainer:buyBonusPopup:baseStakeText");
  buyBonusPopup.closeButton = resourceManager.get("buyABonusContainer:buyBonusPopup:closeButton");
  buyBonusPopup.closeButton.onPressedCallback = buyBonusPopup.onClickedNo;
  buyBonusPopup.stakePreviousButton = resourceManager.get("buyABonusContainer:buyBonusPopup:stakePrevious");
  buyBonusPopup.stakePreviousButton.onPressedCallback = buyBonusPopup.onStakePreviousPressed;
  buyBonusPopup.stakeNextButton = resourceManager.get("buyABonusContainer:buyBonusPopup:stakeNext");
  buyBonusPopup.stakeNextButton.onPressedCallback = buyBonusPopup.onStakeNextPressed;

  const buttonTexts = [
    resourceManager.get("buyABonusContainer:buyBonusPopup:buyBonusBacking:buyABonusLow:lowFreespinsButton:buttonText"),
    resourceManager.get(
      "buyABonusContainer:buyBonusPopup:buyBonusBacking:buyABonusMedium:midFreespinsButton:buttonText"
    ),
    resourceManager.get(
      "buyABonusContainer:buyBonusPopup:buyBonusBacking:buyABonusHigh:highFreespinsButton:buttonText"
    ),
  ];
};

buyBonusPopup.onGameConfig = function (event) {
  buyBonusPopup.gameConfig = event;
  buyBonusPopup.init();
};

buyBonusPopup.onBalanceEvent = function (event) {
  buyBonusPopup.balance = event.data.balance;
};

buyBonusPopup.onClosePopup = function (buyBonus) {
  soundManager.play("buttonPressed");

  if (buyBonus) {
    buyBonusPopup.onStartBonusSpin();
  } else {
    // Not buying a bonus, so reset
  }

  buyBonusPopup.open = false;
  let reels = resourceManager.get("slotContainer:reelContainer");
  reels.alpha = 1.0;

  buyBonusPopup.container.visible = false;
  buyBonusPopup.callback(buyBonus);
};

buyBonusPopup.onStartBonusSpin = function () {
  gameController.stopCyclingWins();
  gameController.inBuyABonus = true;
  gameController.inBuyABonusFirstSpin = true;
  gameController.inBuyABonusLow = buyBonusPopup.buyBonusLow;
  gameController.inBuyABonusMed = buyBonusPopup.buyBonusMed;
  gameController.inBuyABonusHigh = buyBonusPopup.buyBonusHigh;
  gameController.useBuyBonusThresholds = true;

  gameData.winningsMeter.set(0);

  gameController.totalWinnings = 0;
  gameController.amountWonInBaseGame = 0;

  // Remove modal
  messageBus.post("game:modal", {});

  let stakeController = resourceManager.getController("stakeController");
  const numLines = 20;

  const bonusBuyStakes = buyBonusPopup.allStakesCombined;

  // we should be ok to use the combined stake index as the button will be disabled if not an allowable stake
  let baseStake = buyBonusPopup.convertToTotalStake(bonusBuyStakes[buyBonusPopup.combinedStakeIndex]);
  let stakes = stakeController.Stakes;
  let returnStake = stakes.find((stake) => stake === baseStake);

  if (!returnStake) {
    returnStake = stakes[0];
  }

  stakeController.requestChangeStake(returnStake);

  if (buyBonusPopup.buyBonusHigh) {
    stakeController.requestChangeStake(baseStake, "BONUS_BUY_HIGH");
    gameController.bonusBetStake = baseStake;
  } else if (buyBonusPopup.buyBonusMed) {
    stakeController.requestChangeStake(baseStake, "BONUS_BUY_MED");
    gameController.bonusBetStake = baseStake;
  } else {
    stakeController.requestChangeStake(baseStake, "BONUS_BUY_LOW");
    gameController.bonusBetStake = baseStake;
  }

  gameData.bonusBuyStake = baseStake;
  const bpl = baseStake / 1;

  let buyCost;

  if (buyBonusPopup.buyBonusHigh) {
    buyCost = buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsHigh;
  } else if (buyBonusPopup.buyBonusMed) {
    buyCost = buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsMed;
  } else {
    buyCost = buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsLow;
  }

  gdk.startGame(
    {
      stake: baseStake * buyCost,
      numWinlines: 1,
      bpl: bpl,
      metaData: {
        encore: false,
        buyABonus: true,
        buyBonusLowActive: buyBonusPopup.buyBonusLow,
        buyBonusMedActive: buyBonusPopup.buyBonusMed,
        buyBonusHighActive: buyBonusPopup.buyBonusHigh,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

buyBonusPopup.onClickedYesHigh = function () {
  buyBonusPopup.buyBonusLow = false;
  buyBonusPopup.buyBonusMed = false;
  buyBonusPopup.buyBonusHigh = true;

  buyBonusPopup.onClosePopup(true);
};

buyBonusPopup.onClickedYesMid = function () {
  buyBonusPopup.buyBonusLow = false;
  buyBonusPopup.buyBonusHigh = false;
  buyBonusPopup.buyBonusMed = true;

  buyBonusPopup.onClosePopup(true);
};

buyBonusPopup.onClickedYesLow = function () {
  buyBonusPopup.buyBonusLow = true;
  buyBonusPopup.buyBonusMed = false;
  buyBonusPopup.buyBonusHigh = false;

  buyBonusPopup.onClosePopup(true);
};

buyBonusPopup.onClickedNo = function () {
  buyBonusPopup.open = false;

  messageBus.post("game:modal", {});

  buyBonusPopup.onClosePopup(false);
};

buyBonusPopup.onInfo = function () {
  soundManager.play("buttonPressed");
  helpPageManager.showPopup(function () {}, 7);
};

buyBonusPopup.getFilesRequired = function (json) {
  return [];
};

buyBonusPopup.onStakeChanged = function (stake) {
  if (!buyBonusPopup.open && stake !== undefined) {
    if (gameData.stakes.indexOf(stake) !== -1) {
      // only save valid stakes
      gameController.currentNonBABStake = stake;
    }
  }
};

resourceManager.registerObjectType(
  "buyBonusPopup",
  buyBonusPopup.create,
  buyBonusPopup.initialise,
  buyBonusPopup.getFilesRequired
);

messageBus.subscribe("stake:stakeChanged", buyBonusPopup.onStakeChanged);
